/* section-cart-drawer.js — extracted from sections/cart-drawer.liquid */
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('.cart-drawer__overlay');
      this.closeBtn = this.querySelector('.cart-drawer__close');
      this.bodyEl = document.getElementById('cart-drawer-body');
      this.countEl = document.getElementById('cart-drawer-count');
      this._opener = null;

      this.overlay?.addEventListener('click', () => this.close());
      this.closeBtn?.addEventListener('click', () => this.close());
      document.addEventListener('cart:open', (e) => { this._opener = e.detail?.opener || document.activeElement; this.open(); });
      document.addEventListener('cart:updated', () => this.refresh());
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !this.hidden && this.dataset.open !== undefined) this.close();
        if (e.key === 'Tab' && !this.hidden && this.dataset.open !== undefined) this._trapFocus(e);
      });

      this.addEventListener('click', e => {
        let removeBtn = e.target.closest('[data-remove-key]');
        if (removeBtn) this.removeItem(removeBtn.dataset.removeKey);
        let qtyBtn = e.target.closest('[data-qty-action]');
        if (qtyBtn) this.changeQty(qtyBtn.dataset.changeKey, qtyBtn.dataset.qtyAction, qtyBtn.closest('.cart-item__qty'));
      });

      this.setupCartNotes();
      this.setupDiscountCode();
    }

    open() {
      this.hidden = false;
      requestAnimationFrame(() => {
        this.dataset.open = '';
        document.body.style.overflow = 'hidden';
        this.setAttribute('aria-hidden', 'false');
        let firstFocusable = this._getFocusable()[0];
        if (firstFocusable) firstFocusable.focus();
      });
    }

    close() {
      delete this.dataset.open;
      this.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(() => {
        this.hidden = true;
        if (this._opener && typeof this._opener.focus === 'function') {
          this._opener.focus();
        }
        this._opener = null;
      }, 350);
    }

    _getFocusable() {
      return Array.from(
        this.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function(el) { return !el.closest('[hidden]'); });
    }

    _trapFocus(e) {
      let focusable = this._getFocusable();
      if (!focusable.length) return;
      let first = focusable[0];
      let last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    async refresh() {
      try {
        let resp = await fetch('/cart?sections=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        let data = await resp.json();
        if (!data['cart-drawer']) return;

        let parser = new DOMParser();
        let doc = parser.parseFromString(data['cart-drawer'], 'text/html');

        let newBody = doc.getElementById('cart-drawer-body');
        let newFooter = doc.getElementById('cart-drawer-footer');
        let newCount = doc.getElementById('cart-drawer-count');

        if (newBody && this.bodyEl) this.bodyEl.innerHTML = newBody.innerHTML;

        let footerEl = this.querySelector('#cart-drawer-footer');
        if (newFooter && footerEl) {
          footerEl.innerHTML = newFooter.innerHTML;
        } else if (newFooter && !footerEl) {
          this.querySelector('.cart-drawer__panel').appendChild(
            doc.querySelector('.cart-drawer__footer') || newFooter
          );
        }

        let itemCount = newCount ? parseInt(newCount.textContent) || 0 : 0;
        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = itemCount;
          el.hidden = itemCount === 0;
        });
        if (this.countEl) {
          this.countEl.textContent = itemCount;
          this.countEl.hidden = itemCount === 0;
        }

        // Re-attach listeners lost after innerHTML replacement
        this.setupCartNotes();
        this.setupDiscountCode();
      } catch (e) {}
    }

    async removeItem(key) {
      try {
        let resp = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        if (resp.ok) { document.dispatchEvent(new CustomEvent('cart:updated')); }
      } catch (e) {}
    }

    async changeQty(key, action, container) {
      let input = container?.querySelector('.cart-item__qty-input');
      if (!input) return;
      let qty = parseInt(input.value) || 1;
      qty = action === 'plus' ? qty + 1 : Math.max(0, qty - 1);
      input.value = qty;
      try {
        let resp = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        if (resp.ok) { document.dispatchEvent(new CustomEvent('cart:updated')); }
      } catch (e) {}
    }

    setupCartNotes() {
      // Scope to `this` so re-running after refresh targets fresh DOM nodes
      let textarea = this.querySelector('#cart-note-input');
      if (!textarea) return;
      let timer;
      textarea.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ note: textarea.value })
          }).catch(function () {});
        }, 600);
      });
    }

    setupDiscountCode() {
      // Scope to `this` so re-running after refresh targets fresh DOM nodes
      let applyBtn = this.querySelector('#cart-discount-apply');
      let input = this.querySelector('#cart-discount-input');
      if (!applyBtn || !input) return;

      applyBtn.addEventListener('click', function () {
        let code = input.value.trim();
        if (!code) return;
        window.location.href = '/checkout?discount=' + encodeURIComponent(code);
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') applyBtn.click();
      });
    }
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);
